import {Button} from 'components/Button';
import {Box} from 'components/Grid';
import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {IBreadcrumb} from 'modules/seo/types';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';

export const NoEventsInCity: FC<{breadcrumbs?: IBreadcrumb[]}> = ({breadcrumbs = []}) => {
    return (
        <Box>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <div className={style.content}>
                <div className={style.imageContainer}>
                    <img alt={''} className={style.image} src={'/images/events-page/no-events-in-city.webp'} />
                </div>
                <Typography className={style.text} element={'div'} variant={'headline-32-reg-ch'}>
                    К сожалению, в вашем городе пока нет дегустаций в винотеках :(
                </Typography>
                <div className={style.linkBlock}>
                    <Button className={style.link} href={'/catalog'}>
                        <Typography variant={'button-14-m-cl'}>хорошо, посмотрю каталог</Typography>
                    </Button>
                </div>
            </div>
        </Box>
    );
};
